import React, { useEffect, useState } from "react";
import { apiUrl } from "../../config";
import { useLanguage } from "../../LanguageContext";
import { getNumberOfDays } from "../../utils/dynamic";
import { fetchData } from "../../utils/api";


const RoomCard = ({typePage, room, checkIn=null, checkOut=null, bookingPrice, periodStatus = false }) => {
  const [seasonValue, setSeasonValue] = useState(false)
  
  useEffect(() => {
    const get_season_value = async () => {
      try {
        if (checkOut !== null) {
          const response = await fetchData(`${apiUrl}/api/get_season_value?checkout=${checkOut}`, "GET", "", { cache: false })
          setSeasonValue(response.request.bool)
        } else {
          const response = await fetchData(`${apiUrl}/api/get_season_value`, "GET", { cache: false })
          setSeasonValue(response.request.bool)
        }
      } catch (error) {
        // console.error("Ошибка при перенаправлении на банк.")
      }
    }
      get_season_value()
  }, [checkOut])
    const { language } = useLanguage();
    // Состояние для языка
    const langs = {
      'ru': {
        'booking_service': "Услуга бронирования",
        'night': "День, ночь",
        'more_btn': "Детали",
        'available_rooms_title': "Кол. свободных",
        'max_guests_title': "Гостей",
        'rooms_title': "Комнат",
        'full_period': "За весь период",
        'first_day': "Первые сутки",
      },
      'tm': {
        'booking_service': "Bron etmek hyzmaty",
        'night': "Gündiz gije",
        'more_btn': "Maglumat",
        'available_rooms_title': "Bohçalaryň sany",
        'max_guests_title': "Myhmanlaryň sany",
        'rooms_title': "Otag sany",
        'full_period': "Doly möhlet üçin baha",
        'first_day': "Doly möhlet üçin baha",
      },
      'en': {
        'booking_service': "Booking service",
        'night': "Night",
        'more_btn': "More",
        'available_rooms_title': "Available apartments",
        'max_guests_title': "Guests",
        'rooms_title': "Rooms",
        'full_period': "For full period",
        'first_day': "First day",
      }
    };
    let priceForExtraGuests = 0;
    let priceForExtraGuestsForOneDay = 0;
    if (room.id === 1) {
      if (checkIn !== null && checkOut !== null) {
        const daysForExtraGuest = getNumberOfDays(checkIn, checkOut);
        priceForExtraGuests = 120 * daysForExtraGuest;
        priceForExtraGuestsForOneDay = 120;
      } else {
        priceForExtraGuests = 120;
        priceForExtraGuestsForOneDay = 120;
      }
    }
    return (
        <div className="rooms-page-card">
            {room.images &&
              <img src={`${apiUrl}/api/images/${room.images[0]}`} alt={room.translations.room_type} className="rooms-page__image" />
            }
            <div className="rooms-page__details">
                <h3 className="rooms-page__name">{room.translations.room_type}</h3>
                {/* <p className="rooms-page__item">{langs[language].available_rooms_title}: {room.available_rooms}</p> */}
                <p className="rooms-page__item">{langs[language].max_guests_title}: {room.id === 1 ? room.capacity + 1 : room.capacity}</p>
                <p className="rooms-page__item">{langs[language].rooms_title}: {room.rooms_count}</p>
                <div className="rooms-page__prices">
                    {room.booking_price_status !== 0 &&
                      <div className="rooms-page__price-container">
                        <span className="rooms-page__price-discounted">
                            {`TMT ${room.booking_price}`}
                        </span>
                        <span className="rooms-page__price-per-night">
                            / {langs[language].booking_service}
                        </span>
                      </div>
                    }
                    {(room.price - room.booking_price) !== 0 && (room.price - room.booking_price) &&
                      <>
                        {room.price_first_day > 0 &&
                        <div className="rooms-page__price-container">
                          {seasonValue &&
                          <>
                            <span className="rooms-page__price-old">
                                {`TMT ${(periodStatus) && parseInt(room.price_summer) + priceForExtraGuestsForOneDay}`}
                            </span>
                            <span className="rooms-page__discount-badge">
                                -20%
                            </span>
                          </>
                          }
                          <span className="rooms-page__price-discounted">
                              {`TMT ${parseInt(room.price_first_day) + priceForExtraGuestsForOneDay}`} 
                          </span>
                          <span className="rooms-page__price-per-night">
                              / {langs[language].night}
                          </span>
                        </div>
                        }
                        <div className="rooms-page__price-container">
                          {seasonValue &&
                          <>
                            <span className="rooms-page__price-old">
                                {`TMT ${(periodStatus) ? parseInt(room.price_summer * getNumberOfDays(checkIn, checkOut)) + priceForExtraGuests : parseInt(room.price_summer) + priceForExtraGuests}`}
                            </span>
                            <span className="rooms-page__discount-badge">
                                -20%
                            </span>
                          </>
                          }
                          <span className="rooms-page__price-discounted">
                              {`TMT ${(periodStatus) ? parseInt(room.price) + priceForExtraGuests : parseInt(room.price) + priceForExtraGuests}`}
                          </span>
                          <span className="rooms-page__price-per-night">
                              / {(!periodStatus) ? langs[language].night : langs[language].full_period}
                          </span>
                        </div>
                      </>
                    }
                </div>
                {typePage === 'book' ? (
                  <a href={`/rooms/${room.id}/book?checkIn=${checkIn}&checkOut=${checkOut}&periodStatus=${periodStatus}`}
                      className="button-zj pulse-button">{langs[language].more_btn}</a>
                ) : (
                  <a href={`/rooms/${room.id}/view`}
                      className="button-zj">{langs[language].more_btn}</a>
                )}
            </div>
        </div>
  );
};

export default RoomCard;
